'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const SocketResponse=require('../../../dist-es6/client/dtos/socketResponse');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');let

PersonService=class PersonService extends BaseService{
static get $inject(){return['socketService']}

constructor(socketService){
super();
this._socketService=socketService;
}

async getAllPersons(){
return await this._socketService.sendAndWaitForResponse('GetAllPersons');
}

async getPersonInfoFor(personId,getPredictedWorkday=!1){
let socketResponse=await this._socketService.sendAndWaitForResponse('GetPersonInfo',{personId,getPredictedWorkday});

if(!SocketResponse.succeeded(socketResponse)){
return socketResponse;
}

const personInfo=socketResponse.body;

if(_.exists(personInfo.creationTime)){
personInfo.creationTime=new Date(personInfo.creationTime);
}

if(_.exists(personInfo.predictedWorkday)){
personInfo.predictedWorkday=new TimeInterval(personInfo.predictedWorkday);
}

return socketResponse;
}};


module.exports=PersonService;
//# sourceMappingURL=personService.js.map
